export default "__VITE_ASSET__XQSXh8bH__"